import { Components, Theme } from '@mui/material';

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    rounded: true;
  }
}

export const paperStyles: Components<Theme>['MuiPaper'] = {
  defaultProps: {
    elevation: 2
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      switch (ownerState.variant) {
        case 'rounded': {
          return {
            borderRadius: '0px 8px 8px 8px',
            padding: '8px 10px',
            boxShadow: 'none'
          };
        }

        default: {
          return {
            borderRadius: 0,
            border: theme.palette.border.small.grey.medium,
            boxShadow: 'none'
          };
        }
      }
    }
  }
};
